import React from 'react';
import styled from 'styled-components';
import {
  ButtonSize,
  ButtonVariant,
  // biome-ignore lint/style/noRestrictedImports: we don't want the tracking/logic in Button in this file
  StyledButton,
} from '../components/reusable/Button';
import Text, { TextKind } from '../components/reusable/Text';

const StyledErrorComponent = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`;

export const NetworkErrorPage: React.FC<{ resetErrorCount: () => void }> = ({
  resetErrorCount,
}) => {
  const handleRetry = () => {
    resetErrorCount();
  };

  return (
    <StyledErrorComponent data-testid="network-error-page">
      <Text kind={TextKind.TitleM} component="h1">
        Connection Error
      </Text>
      <Text kind={TextKind.BodyL} style={{ textAlign: 'center' }}>
        We're having trouble connecting to the server. This could be due to a
        network issue or the server being temporarily unavailable.
      </Text>
      <Text kind={TextKind.BodyM} style={{ textAlign: 'center' }}>
        Please check your internet connection and try again.
      </Text>
      <StyledButton
        $size={ButtonSize.Medium}
        $variant={ButtonVariant.Dark}
        $fullWidth={false}
        $fullHeight={false}
        type="button"
        onClick={handleRetry}
        data-testid="retry-button"
      >
        Retry
      </StyledButton>
    </StyledErrorComponent>
  );
};
